import { render } from "./DebugPrintingSection.vue?vue&type=template&id=1936eb18"
import script from "./DebugPrintingSection.vue?vue&type=script&lang=js"
export * from "./DebugPrintingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__